/**
 * DetailView - Toolbar + scrollable content split layout
 * Used for detail/sub-views that need a fixed toolbar above scrollable content.
 */

import { ReactNode } from 'react';

interface DetailViewProps {
  /** Fixed toolbar content (back button, tabs, etc.) */
  toolbar: ReactNode;
  /** Scrollable content area */
  children: ReactNode;
}

export function DetailView({ toolbar, children }: DetailViewProps) {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {toolbar}
      {children}
    </div>
  );
}
